<p-dialog
    [visible]="true"
    [modal]="true"
    [closable]="true"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    styleClass="dga-dialog"
    (onHide)="cancel()">

    <ng-template pTemplate="header"></ng-template>

    <div class="dga-body">

        <!-- Carregando a prévia -->
        <div *ngIf="loadingPreview" class="dga-loading">
            <p-progressSpinner styleClass="dga-spinner" strokeWidth="4" />
        </div>

        <!-- Prévia falhou -->
        <div *ngIf="!loadingPreview && previewError" class="dga-error-state">
            <i class="pi pi-exclamation-circle"></i>
            <p>{{ 'tuner.downgradeAffiliates.loadError' | transloco }}</p>
            <button class="dga-btn-ghost" (click)="retryLoadPreview()">
                {{ 'tuner.downgradeAffiliates.retryBtn' | transloco }}
            </button>
        </div>

        <!-- PASSO 1: escolher quem fica (ou só ver a perda de cashback) -->
        <ng-container *ngIf="!loadingPreview && !previewError && preview && step === 'select'">
            <div class="dga-icon"><i class="pi pi-users"></i></div>

            <ng-container *ngIf="preview.requiresSelection; else noSelection">
                <h3 class="dga-title">
                    {{ 'tuner.downgradeAffiliates.select.titleWithSelection' | transloco: { plan: preview.targetPlanName } }}
                </h3>
                <p class="dga-desc">
                    {{ 'tuner.downgradeAffiliates.select.descWithSelection' | transloco: { plan: preview.targetPlanName, limit: preview.affiliateLimit, active: preview.activeCount } }}
                </p>

                <div class="dga-counter" [class.is-complete]="selected.size === preview.mustKeep">
                    {{ 'tuner.downgradeAffiliates.select.counter' | transloco: { selected: selected.size, total: preview.mustKeep } }}
                </div>

                <div class="dga-client-list">
                    <div *ngFor="let client of preview.clients"
                         class="dga-client-row"
                         [class.selected]="isSelected(client.userId)"
                         (click)="toggle(client.userId)">
                        <div class="dga-client-check">
                            <i class="pi" [class.pi-check-square]="isSelected(client.userId)" [class.pi-stop]="!isSelected(client.userId)"></i>
                        </div>
                        <div class="dga-client-info">
                            <span class="dga-client-name">{{ client.name }}</span>
                            <span class="dga-client-plan">{{ client.planName }}</span>
                        </div>
                        <div class="dga-client-cashback">
                            {{ currencyPrefix }} {{ client.monthlyCashback | number:'1.2-2' }}{{ 'tuner.downgradeAffiliates.select.perMonth' | transloco }}
                        </div>
                    </div>
                </div>

                <div class="dga-loss-summary">
                    <span>{{ 'tuner.downgradeAffiliates.select.cashbackLossLabel' | transloco }}</span>
                    <strong>{{ currencyPrefix }} {{ cashbackLoss | number:'1.2-2' }}</strong>
                </div>
            </ng-container>

            <ng-template #noSelection>
                <h3 class="dga-title">{{ 'tuner.downgradeAffiliates.select.titleNoSelection' | transloco }}</h3>
                <p class="dga-desc">
                    {{ 'tuner.downgradeAffiliates.select.descNoSelection' | transloco: { plan: preview.targetPlanName, active: preview.activeCount } }}
                </p>
                <div class="dga-loss-summary">
                    <span>{{ 'tuner.downgradeAffiliates.select.cashbackLossLabel' | transloco }}</span>
                    <strong>{{ currencyPrefix }} {{ preview.monthlyCashbackTotal | number:'1.2-2' }}</strong>
                </div>
            </ng-template>

            <div class="dga-actions">
                <button class="dga-btn-ghost" (click)="cancel()">
                    {{ 'tuner.downgradeAffiliates.select.cancelBtn' | transloco }}
                </button>
                <button class="dga-btn-primary" [disabled]="!canAdvance" (click)="advance()">
                    {{ 'tuner.downgradeAffiliates.select.nextBtn' | transloco }}
                    <i class="pi pi-arrow-right"></i>
                </button>
            </div>
        </ng-container>

        <!-- PASSO 2: confirmação separada -->
        <ng-container *ngIf="!loadingPreview && !previewError && preview && step === 'sure'">

            <div *ngIf="confirming" class="dga-loading">
                <p-progressSpinner styleClass="dga-spinner" strokeWidth="4" />
                <p>{{ 'tuner.downgradeAffiliates.sure.confirming' | transloco }}</p>
            </div>

            <div *ngIf="!confirming && confirmError" class="dga-error-state">
                <i class="pi pi-exclamation-circle"></i>
                <p>{{ (confirmErrorPermanent
                          ? 'tuner.downgradeAffiliates.sure.confirmErrorPermanent'
                          : 'tuner.downgradeAffiliates.sure.confirmError') | transloco }}</p>
                <div class="dga-actions">
                    <button class="dga-btn-ghost" (click)="cancel()">
                        {{ 'tuner.downgradeAffiliates.sure.cancelBtn' | transloco }}
                    </button>
                    <!-- tuner.downgrade.* é condição que não muda tentando de novo: sem retry,
                         só a saída. -->
                    <button *ngIf="!confirmErrorPermanent" class="dga-btn-primary" (click)="retryConfirm()">
                        {{ 'tuner.downgradeAffiliates.retryBtn' | transloco }}
                    </button>
                </div>
            </div>

            <ng-container *ngIf="!confirming && !confirmError && confirmResult">
                <div class="dga-icon dga-icon-warn"><i class="pi pi-calendar-times"></i></div>

                <h3 class="dga-title">
                    {{ (preview.requiresSelection
                          ? 'tuner.downgradeAffiliates.sure.titleWithSelection'
                          : 'tuner.downgradeAffiliates.sure.titleNoSelection') | transloco }}
                </h3>

                <!-- Nada foi agendado no Stripe ainda — só a escolha foi gravada. A palavra
                     "agendado" fica reservada para a tela de sucesso, depois do checkout. -->
                <p class="dga-desc" *ngIf="preview.requiresSelection">
                    {{ 'tuner.downgradeAffiliates.sure.descWithSelection' | transloco }}
                </p>

                <div class="dga-sure-summary">
                    <div class="dga-sure-row" *ngIf="preview.requiresSelection">
                        <span>{{ 'tuner.downgradeAffiliates.sure.keptLabel' | transloco }}</span>
                        <strong>{{ confirmResult.keptCount }}</strong>
                    </div>
                    <!-- willRemoveCount vem do confirm (leitura fresca do banco), não da seleção
                         local: entre o preview e este confirm outro cliente pode ter sido
                         aceito, e é essa contagem autoritativa que tem que aparecer aqui. -->
                    <div class="dga-sure-row" *ngIf="preview.requiresSelection">
                        <span>{{ 'tuner.downgradeAffiliates.sure.removedLabel' | transloco }}</span>
                        <strong>{{ confirmResult.willRemoveCount }}</strong>
                    </div>
                    <div class="dga-sure-row">
                        <span>{{ 'tuner.downgradeAffiliates.sure.cashbackLossLabel' | transloco }}</span>
                        <strong>{{ currencyPrefix }} {{ cashbackLoss | number:'1.2-2' }}</strong>
                    </div>
                    <div class="dga-sure-row" *ngIf="confirmResult.effectiveAt">
                        <span>{{ 'tuner.downgradeAffiliates.sure.effectiveAtLabel' | transloco }}</span>
                        <strong>{{ confirmResult.effectiveAt | date:'dd/MM/yyyy' }}</strong>
                    </div>
                </div>

                <!-- Os três avisos obrigatórios só fazem sentido quando algo é de fato
                     removido — no caminho sem seleção ninguém sai, e dizer "só os
                     selecionados sobrevivem" seria falso. -->
                <ul class="dga-warnings" *ngIf="preview.requiresSelection">
                    <li>{{ 'tuner.downgradeAffiliates.sure.warning1' | transloco }}</li>
                    <li>{{ 'tuner.downgradeAffiliates.sure.warning2' | transloco }}</li>
                    <li>{{ 'tuner.downgradeAffiliates.sure.warning3' | transloco }}</li>
                </ul>

                <p class="dga-desc" *ngIf="!preview.requiresSelection">
                    {{ 'tuner.downgradeAffiliates.sure.noSelectionNote' | transloco }}
                </p>

                <div class="dga-actions">
                    <button class="dga-btn-ghost" (click)="cancel()">
                        {{ 'tuner.downgradeAffiliates.sure.cancelBtn' | transloco }}
                    </button>
                    <button class="dga-btn-primary" (click)="proceed()">
                        {{ 'tuner.downgradeAffiliates.sure.continueBtn' | transloco }}
                        <i class="pi pi-check"></i>
                    </button>
                </div>
            </ng-container>
        </ng-container>

    </div>
</p-dialog>
